<template>
  <div class="allOrder">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="课程" name="first"></el-tab-pane>
      <el-tab-pane label="教材" name="second"></el-tab-pane>
    </el-tabs> -->
    <div class="list" v-if="list && list.length > 0">
      <div v-for="(item, index) in list" :key="index" class="item">
        <div class="classView">
          <div class="box">
            <img class="item-img" :src="item.mimg" @click="toDetail(item)" />
            <!-- <div class="course_type">
              <span>知识套餐</span>
            </div> -->
            <div class="item-content" @click="toDetail(item)">
              <div class="item_name-box">
                <div class="item-text elp">{{ item.tiitle }}</div>
              </div>
              <div class="type">{{ showTypeEnums[item.type] }}</div>
            </div>
            <div class="btnBox">
              <div class="cancelBtn" @click="toCancel(item)">取消收藏</div>
              <div class="collectionBtn" @click="toDetail(item)">去查看</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nothing" v-if="!list || list.length == 0">
      <div class="nothing-text">暂无收藏内容哦~</div>
    </div>
    <!-- 分页 -->
    <el-pagination class="pagination colleges-pagination" :total="total" :current-page="pageNum"
      :page-sizes="[8, 16, 24, 40]" :page-size="pageSize" background layout="total, sizes, prev, pager, next"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" />
  </div>
</template>

<script>
import { showTypeEnums } from "@/api/emun";
import { Know } from "@/api/know";

let know = new Know();
export default {
  data() {
    return {
      list: [],
      pageSize: 8,
      activeName: 'first',
      // 订单 第几页
      pageNum: 1,
      total: 0,
      showTypeEnums: showTypeEnums,
    };
  },
  created() {
    this.getList();
    this.userInfo = localStorage.getItem('userId')
  },
  methods: {
    async getList() {
      const { total, rows } = await know.getStuCollectProductList({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        type: 1,
      });

      this.list = rows;
      this.total = total;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    toCancel(item) {
      know.collectProduct({ type: 1, typeId: item.typeId, stuId: this.userInfo, status: 0 })
        .then((res) => {
          if (res.code === 0) {
            this.getList();
          }
        })
    },
    toDetail(item) {
      if (item.productLine == 3) {
        const routeUrl = this.$router.resolve({
          path: "/VIP/VIPClassxq",
          query: {
            id: item.typeId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        const routeUrl = this.$router.resolve({
          path: "/typeclassxq",
          query: {
            id: item.typeId,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.allOrder {
  width: 100%;
  min-height: 536px;
  padding-bottom: 20px;
  background-color: #ffffff;
  padding-top: 10px;

  .list {
    width: 100%;
    // padding: 20px 50px;

    .classView {
      // box-shadow: 0px 0px 12px 1px rgba(204, 204, 204, 0.34);
      min-height: 133px;
      padding: 14px 20px;
      border-radius: 8px;
      cursor: pointer;

      .box {
        display: flex;
        align-items: flex-start;
        position: relative;

        .item-img {
          width: 205px;
          height: 114px;
          border-radius: 8px 8px 8px 8px;
          opacity: 1;
        }

        .item-content {
          height: 108px !important;
        }

        .btnBox {
          height: 108px;
          display: flex;
          align-items: center;
          z-index: 1;
          margin-left: -150px;

          .cancelBtn {
            width: 110px;
            height: 36px;
            border-radius: 18px 18px 18px 18px;
            opacity: 1;
            border: 1px solid #a6a6a6;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #a6a6a6;
            line-height: 36px;
            margin-right: 20px;
          }

          ;

          .collectionBtn {
            width: 110px;
            height: 36px;
            border-radius: 18px 18px 18px 18px;
            opacity: 1;
            border: 1px solid #006de7;
            text-align: center;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #006de7;
            line-height: 36px;
          }
        }
      }

      .bottom_box {
        width: 776px;
        background-color: #f9f9f9;
        border-radius: 8px;
        margin-top: 15px;

        .chapter_item {
          height: 110px;
          width: 746px;
          padding: 16px;
          border-bottom: 1px solid #eeeeee;
          display: flex;
          justify-content: space-between;

          .left_box {
            .title_box {
              margin-bottom: 9px;
              display: flex;
              align-items: center;

              .tag {
                display: inline-block;
                padding: 2px 8px;
                height: 22px;
                border-radius: 0 8px 0 8px;
                background: linear-gradient(132deg, #fff3eb 0%, #ffedeb 100%);
                margin-right: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ff6e2d;
                font-size: 12px;
                flex-shrink: 0;

                .tag_img {
                  width: 11px;
                  margin-right: 3px;
                }
              }

              .title {
                color: #333333;
                width: 400px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;
              }
            }

            .time {
              color: #aaaaaa;
              font-size: 14px;
              display: flex;
              align-items: center;
              margin-bottom: 19px;

              .time_img {
                width: 14px;
                height: 14px;
                margin-right: 6px;
                flex-shrink: 0;
              }
            }

            .progress_box {
              display: flex;
              align-items: center;

              .progress_bar {
                width: 286px;
                height: 8px;
                background-color: #e5e5e5;
                border-radius: 10px;

                .schedule {
                  background: linear-gradient(90deg, #a5bdff 0%, #2871ff 100%);
                  height: 8px;
                  width: 0;
                  border-radius: 10px;
                }
              }

              .text {
                font-size: 12px;
                color: #2871ff;
                margin-left: 8px;
              }
            }
          }

          .right_box {
            display: flex;
            align-items: center;

            .btn_item {
              width: 80px;
              height: 30px;
              border-radius: 4px;
              border: 1px solid #ff5e51;
              color: #ff5e51;
              font-size: 13px;
              text-align: center;
              line-height: 30px;
              margin-left: 14px;
              cursor: pointer;
            }
          }
        }

        .chapter_item:last-child {
          border-bottom: 0;
        }
      }

      .bottom_boxs {
        background-color: #fff;

        .chapter_item {
          background-color: #f9f9f9;
        }

        .zhang_item {
          display: flex;
          align-items: center;
          padding: 14px 0;

          .time_img {
            display: block;
            width: 14px;
            height: 12px;
            margin-right: 8px;
            flex-shrink: 0;
          }

          .zhang_item_name {
            width: 660px;
          }

          .zhang_item_last {
            flex-shrink: 0;
            width: 40px;
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #aaaaaa;
            cursor: pointer;

            .iconfont {
              font-size: 12px;
            }
          }
        }

        .chapter_items {
          height: 82px;

          .left_box {
            .title_box {
              // margin-bottom: 27px;
            }

            .title {
              font-size: 16px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
          }

          .progress_box {
            margin-top: 17px;
          }
        }
      }
    }

    .price {
      font-size: 18px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: Bold;
      color: #ff5e51;
      line-height: 18px;
      margin-top: 7px;
    }

    .item {
      width: 995px;
      // height: 134px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.06);
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      position: relative;
      margin-bottom: 20px;

      .item-img {
        flex-shrink: 0;
        margin-right: 14px;
      }

      .item-content {
        width: 100%;
        z-index: 0;

        .item_name-box {
          display: flex;
          align-items: center;
          margin-top: 5px;

          .item-tips {
            width: 52px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid #ff7b1c;
            font-size: 12px;
            color: #ff7b1c;
            text-align: center;
            line-height: 20px;
            margin-right: 8px;
          }

          .item-text {
            width: 600px;
            height: 16px;
            font-size: 16px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            line-height: 16px;
          }
        }

        .type {
          width: 60px;
          height: 20px;
          border-radius: 18px 18px 18px 18px;
          opacity: 1;
          border: 1px solid #a6a6a6;
          text-align: center;
          font-size: 10px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #a6a6a6;
          line-height: 20px;
          margin-top: 20px;
        }

        .endTime {
          font-size: 13px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 500;
          color: #a6a6a6;
          margin-top: 25px;
        }

        .tips {
          display: flex;
          align-items: center;
          margin-top: 16px;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #ff7b1c;
          line-height: 12px;

          .item-tips {
            background-color: #fff2e9;
            padding: 4px 7px;
            border-radius: 4px;
            margin-right: 8px;
          }
        }

        /* 专属 */
        .typeList {
          margin-top: 24px;
          /* position: absolute;
          bottom: 13px; */
          display: flex;
          align-items: center;

          .type-name {
            width: 44px;
            height: 24px;
            background: #c4c4c4 linear-gradient(134deg, #616f79 0%, #232733 100%);
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            font-size: 12px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffe2b5;
            line-height: 24px;
            text-align: center;
          }

          .type-coufig {
            height: 22px;
            background: linear-gradient(118deg, #fcefd0 0%, #ffda9b 100%);
            border-radius: 0px 4px 4px 0px;
            opacity: 1;
            font-size: 12px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #834917;
            line-height: 22px;
            padding: 0px 8px;
          }
        }
      }
    }

    .course_type {
      width: 56px;
      height: 21px;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 8px 0 8px 0;
      color: #ffffff;
      font-size: 11px;
      text-align: center;
      line-height: 21px;
    }
  }

  // 分页
  .el-pagination {
    width: auto;
    height: auto;
    margin: 20px auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>